<template>
    <div class="newsNoticeLeft">
        <div class="newsNoticeLeftTitle">
            <!-- <img src="../../../static/supply/xm.png" /> -->
            <span> {{ type }}</span>
        </div>
        <div class="newsNoticeLeftBtnGrounp">
            <div class="navig_list">
                <div class="button_name" v-for="(item, index) in list" :key="index"
                    :class="{ 'tabBtnActive': switchTypeindex == index }" @click="navItem(item.name, index, item.id)">
                    <div>{{ item.name }}</div>
                    <div>
                        <el-icon>
                            <ArrowRightBold />
                        </el-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
/**
     * itemList 列表
     * @property {Array} list 列表数据
     * @event {Function} goHomePage 去主页
     * @event {Function} navItem 点击事件
     * @event {Function} switchTypeindex 默认列表
     */

export default {
    props: {
        list: {
            type: Array,
            default: function () {
                return []
            }
        },
        type: {
            type: String,
            default: 'information'
        },
        switchTypeindex:{
            type: Number,
            default: 0,
        }

    },
    methods: {
        navItem(name,index,id) {
            this.$emit('navItem', name,index, id)
        }
    }
}
</script>
<style lang="less" scoped>
.newsNoticeLeft {
    width: 226px;
    box-shadow: 1px 1px 10px #ddd;
    background: #FFFFFF;

    //   border-top: 5px solid #09589c;
    .newsNoticeLeftTitle {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        // color:#0e932e ;
        color: #000000;
        // background-color: rgba(0, 149, 91, 1);
        height: 70px;
        line-height: 70px;
        text-align: center;
        border-bottom: 1px solid #EEF0F3;

        img {
            width: 40px;
            height: 40px;
            vertical-align: middle;
        }
    }

    .newsNoticeLeftBtnGrounp {
        // margin-top: 30px;
        display: flex;
        flex-direction: column;

        .navig_list {
            width: 200px;
            height: 100%;
            margin: 0 auto;

            .button_name {
                border-width: 0px;
                width: 200px;
                height: 47px;
                background: inherit;
                background-color: rgba(242, 242, 242, 1);
                border: none;
                border-radius: 0px;
                display: flex;
                justify-content: space-around;
                color: #333333;
                font-family: Source Han Sans CN;
                line-height: 47px;
                margin-top: 15px;
                cursor: pointer;
            }

            .tabBtnActive {
                border-width: 0px;
                width: 200px;
                height: 47px;
                background: inherit;
                background-color: #02A7F0;
                border: none;
                border-radius: 0px;
                display: flex;
                justify-content: space-around;
                color: #ffff;
                font-family: Source Han Sans CN;
                line-height: 47px;
                margin-top: 15px;

            }

        }

    }
}
</style>



// WEBPACK FOOTER //
// src/studio/policy/components/navigationList.vue